import { API } from 'src/constants/api';
import { axiosInterceptor } from 'src/utils/interceptors';

export const roleList = async (payload?: any, signal?: any) => {
    const uri = API.Roles.list + payload;
    const response = await axiosInterceptor.get(uri, { signal: signal });
    return response;
};
export const roleUpdate = async (payload?: any) => {
    const uri = API.Roles.update;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};

export const createRole = async (payload?: any) => {
    const uri = API.Roles.create;
    const response = await axiosInterceptor.post(uri, payload);
    return response;
};
